import { Component, Input } from '@angular/core';

import { clienteCarteiraTipoRealizada } from '../../cliente-carteira-tipo';

@Component({
    selector: 'sgt-cliente-carteira-tipo-realizada-badge',
    templateUrl: './cliente-carteira-tipo-realizada-badge.component.html',
    styleUrls: ['./cliente-carteira-tipo-realizada-badge.component.less']
})
export class ClienteCarteiraTipoRealizadaBadgeComponent {
    tipo = clienteCarteiraTipoRealizada;

    /** Se o badge está inserido dentro dos badges do título de um card no pipeline */
    @Input() isPipelineCardTitleBadge = false;
}
